import { STAFF_COLOR } from 'shared/consts';
import styled from 'styled-components';

export const CircleButton = styled.button`
	border-radius: 100%;
	height: 40px;
	width: 40px;
	background: ${STAFF_COLOR};
	padding-bottom: 4px;
	font-size: 22px;
	font-weight: bold;
	color: white;
`;
